export default __webpack_public_path__ + "static/media/logo-bank-bca.86aea6fe.png";